import React from 'react'

import ListingStoryCard, {
  Story,
} from '../../../components/cards/ListingStoryCard'

import { Section, SectionTitle } from './shared'

type ListingStoriesProps = {
  listing: {
    stories: Story[]
  }
}

const ListingStories = ({ listing }: ListingStoriesProps) => (
  <Section
    // @ts-ignore -- not typed yet
    borderTop
  >
    <SectionTitle>Featured in these Stories</SectionTitle>
    {listing.stories.map((story) => (
      <ListingStoryCard
        key={story.id}
        story={story}
        photos={[{ image: story.promo_image }, ...story.photos]}
      />
    ))}
  </Section>
)

export default ListingStories
